import {
    OTHER_DETAILS,
    VENDOR_INFORMATION,
    VENDOR_ADDRESS,
    STATION_TYPE,
    STATION_DETAILS,
    MOBILE_FREQUENCY_INFO,
    LAND_FIXED_RADIO_EQUIPMENT_INFO,
    LAND_FIXED_FREQUENCY_INFO,
    ANTENNA_INFORMATION,
    ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION,
    FILTER_INFORMATION,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/SPSApplication';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatSPSApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let baseLandFixedStationInfo = [];
    let mobilePortableStationInfo = [];
    let mobileStationFrequencyInfo = [];
    let landFixedEquipmentInfo = [];
    let landFixedStationFrequencyInfo = [];
    let filterInfo = [];

    newDocs = [];

    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    for (const key in licenceDetails.supportingDocuments) {
        if (licenceDetails.supportingDocuments.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.supportingDocuments[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.baseLandFixedStationInfo && licenceDetails.baseLandFixedStationInfo.length > 0) {
        baseLandFixedStationInfo = licenceDetails?.baseLandFixedStationInfo
            ?.map((value: any) => ({
                'location-of-station': value?.locationOfStationEGRooftop ?? '-',
                'building-name': value?.stationAddress?.buildingName ?? '-',
                'postal-code': value?.stationAddress?.postalCode ?? '-',
                'street-name': value?.stationAddress?.streetName ?? '-',
                'block-house-no': value?.stationAddress?.blockNo ?? '-',
                'floor-level': value?.stationAddress?.floor ?? '-',
                unit: value?.stationAddress?.unit ?? '-',
                'latitude-degrees': value?.latitudeDegrees ?? '-',
                'latitude-minutes': value?.latitudeMinutes ?? '-',
                'latitude-seconds': value?.latitudeSeconds ?? '-',
                'longitude-degrees': value?.longitudeDegrees ?? '-',
                'longitude-minutes': value?.longitudeMinutes ?? '-',
                'longitude-seconds': value?.longitudeSeconds ?? '-',
                'building-height-m': value?.buildingHeightM ?? '-',
                'antenna-structure-height-m': value?.stationAntennaEffectiveHeightMAboveGroundLevel ?? '-',
                'antenna-elevation-angle': value?.stationElevationAngle ?? '-',
                transportable: value?.transportable ?? '-',
                'radius-of-operation': value?.radiusOfOperationKm ?? '-'
            }))
            .map((item: any, index: number) => {
                if (index === 0) {
                    return item;
                }
                return {
                    [`location-of-station-${index}`]: item['location-of-station'],
                    [`building-name-${index}`]: item['building-name'],
                    [`postal-code-${index}`]: item['postal-code'],
                    [`street-name-${index}`]: item['street-name'],
                    [`block-house-no-${index}`]: item['block-house-no'],
                    [`floor-level-${index}`]: item['floor-level'],
                    [`unit-${index}`]: item['unit'],
                    [`latitude-degrees-${index}`]: item['latitude-degrees'],
                    [`latitude-minutes-${index}`]: item['latitude-minutes'],
                    [`latitude-seconds-${index}`]: item['latitude-seconds'],
                    [`longitude-degrees-${index}`]: item['longitude-degrees'],
                    [`longitude-minutes-${index}`]: item['longitude-minutes'],
                    [`longitude-seconds-${index}`]: item['longitude-seconds'],
                    [`building-height-m-${index}`]: item['building-height-m'],
                    [`antenna-structure-height-m-${index}`]: item['antenna-structure-height-m'],
                    [`antenna-elevation-angle-${index}`]: item['antenna-elevation-angle'],
                    [`transportable-${index}`]: item['transportable'],
                    [`radius-of-operation-${index}`]: item['radius-of-operation']
                };
            });
    }

    if (licenceDetails && licenceDetails.mobilePortableStationInfo && licenceDetails.mobilePortableStationInfo.length > 0) {
        mobilePortableStationInfo = licenceDetails?.mobilePortableStationInfo
            ?.map((value: any, i: number) => ({
                'station-name': value?.stationName ?? '-',
                'latitude-degrees': value?.latitudeDegrees ?? '-',
                'latitude-minutes': value?.latitudeMinutes ?? '-',
                'latitude-seconds': value?.latitudeSeconds ?? '-',
                'longitude-degrees': value?.longitudeDegrees ?? '-',
                'longitude-minutes': value?.longitudeMinutes ?? '-',
                'longitude-seconds': value?.longitudeSeconds ?? '-',
                'building-name': value?.stationAddress?.buildingName ?? '-',
                'postal-code': value?.stationAddress?.postalCode ?? '-',
                'street-name': value?.stationAddress?.streetName ?? '-',
                'block-house-no': value?.stationAddress?.blockNo ?? '-',
                'floor-level': value?.stationAddress?.floor ?? '-',
                unit: value?.stationAddress?.unit ?? '-',
                manufacturer: value?.equipmentInfo[i]?.manufacturer,
                model: value?.equipmentInfo[i]?.model,
                'output-power-w': value?.equipmentInfo[i]?.outputPowerW,
                'number-of-mobile-portables': value?.equipmentInfo[i]?.noOfMobiles
            }))
            .map((item: any, index: number) => {
                if (index === 0) {
                    return item;
                }
                return {
                    [`station-name-${index}`]: item['station-name'],
                    [`latitude-degrees-${index}`]: item['latitude-degrees'],
                    [`latitude-minutes-${index}`]: item['latitude-minutes'],
                    [`latitude-seconds-${index}`]: item['latitude-seconds'],
                    [`longitude-degrees-${index}`]: item['longitude-degrees'],
                    [`longitude-minutes-${index}`]: item['longitude-minutes'],
                    [`longitude-seconds-${index}`]: item['longitude-seconds'],
                    [`building-name-${index}`]: item['building-name'],
                    [`postal-code-${index}`]: item['postal-code'],
                    [`street-name-${index}`]: item['street-name'],
                    [`block-house-no-${index}`]: item['block-house-no'],
                    [`floor-level-${index}`]: item['floor-level'],
                    [`manufacturer-${index}`]: item['manufacturer'],
                    [`model-${index}`]: item['model'],
                    [`output-power-w-${index}`]: item['output-power-w'],
                    [`number-of-mobile-portables-${index}`]: item['number-of-mobile-portables']
                };
            });
    }

    if (
        licenceDetails &&
        licenceDetails.mobilePortableStationInfo[0]?.mobileStationFrequencyInfo &&
        licenceDetails.mobilePortableStationInfo[0]?.mobileStationFrequencyInfo.length > 0
    ) {
        mobileStationFrequencyInfo = licenceDetails?.mobilePortableStationInfo[0]?.mobileStationFrequencyInfo.map(
            (value: Record<string, string>, i: number) => ({
                no: value?.rowId ?? '-',
                'transmit-frequency-mhz-from': value?.desiredFrequencyMHzFromTransmit ?? '-',
                'transmit-frequency-mhz-to': value?.desiredFrequencyMHzToTransmit ?? '-',
                'transmit-bandwidth-khz': value?.bandwidthKHzTransmit ?? '-',
                'receive-frequency-mhz-from': value?.desiredFrequencyMHzFromReceive ?? '-',
                'receive-frequency-mhz-to': value?.desiredFrequencyMHzToReceive ?? '-',
                'receive-bandwidth-khz': value?.bandwidthKHzReceive ?? '-',
                'emission-class-transmit': value?.emissionClassTransmit ?? '-'
            })
        );
    }

    if (
        licenceDetails &&
        licenceDetails.baseLandFixedStationInfo[0]?.equipmentInfo &&
        licenceDetails.baseLandFixedStationInfo[0]?.equipmentInfo.length > 0
    ) {
        landFixedEquipmentInfo = licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo.map(
            (value: Record<string, string>, i: number) => ({
                no: value?.rowId ?? '-',
                'manufacturer-transmitter': value?.manufacturerTransmitter ?? '-',
                'manufacturer-receiver': value?.manufacturerReceiver ?? '-',
                'model-transmitter': value?.modelTransmitter ?? '-',
                'model-receiver': value?.modelReceiver ?? '-',
                'output-power-transmitter': value?.outputPowerWTransmitter ?? '-'
            })
        );
    }

    if (
        licenceDetails &&
        licenceDetails.baseLandFixedStationInfo[0]?.frequencyAndEmissionClassInformation &&
        licenceDetails.baseLandFixedStationInfo[0]?.frequencyAndEmissionClassInformation.length > 0
    ) {
        landFixedStationFrequencyInfo = licenceDetails?.baseLandFixedStationInfo[0]?.frequencyAndEmissionClassInformation.map(
            (value: Record<string, string>, i: number) => ({
                no: value?.rowId ?? '-',
                'start-time': value?.startTime ?? '-',
                'stop-time': value?.stopTime ?? '-',
                'desired-frequency-mhz-from-transmit': value?.desiredFrequencyMHzFromTransmit ?? '-',
                'desired-frequency-mhz-to-transmit': value?.desiredFrequencyMHzToTransmit ?? '-',
                'desired-frequency-mhz-from-receive': value?.desiredFrequencyMHzFromReceive ?? '-',
                'desired-frequency-mhz-to-receive': value?.desiredFrequencyMHzToReceive ?? '-',
                'feeder-line-type-transmit': value?.feederLineTypeTransmit ?? '-',
                'feeder-line-type-receive': value?.feederLineTypeReceive ?? '-',
                'feeder-line-length-m-transmit': value?.feederLineLengthMTransmit ?? '-',
                'feeder-line-length-m-receive': value?.feederLineLengthMReceive ?? '-',
                'feeder-line-loss-db-transmit': value?.feederLineLossDBTransmit ?? '-',
                'feeder-line-loss-db-receive': value?.feederLineLossDBReceive ?? '-',
                'bandwidth-khz-transmit': value?.bandwidthKHzTransmit ?? '-',
                'bandwidth-khz-receive': value?.bandwidthKHzReceive ?? '-',
                'emission-class-transmit': value?.emissionClassTransmit ?? '-'
            })
        );
    }

    if (
        licenceDetails &&
        licenceDetails.baseLandFixedStationInfo[0]?.filterInfo &&
        licenceDetails.baseLandFixedStationInfo[0]?.filterInfo.length > 0
    ) {
        filterInfo = licenceDetails?.baseLandFixedStationInfo[0]?.filterInfo.map((value: Record<string, string>, i: number) => ({
            no: value?.rowId ?? '-',
            manufacturer: value?.filterManufacturer ?? '-',
            model: value?.model ?? '-',
            'insertion-loss-db': value?.insertionLossDB ?? '-',
            'tuned-frequency-mhz': value?.tunedFrequencyMHz ?? '-'
        }));
    }

    licence = {
        id: 'special-purpose-station-licence',
        formID: 'special-purpose-station-licence',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${OTHER_DETAILS}-proposed-used-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystem ?? '-',

            [`${STATION_TYPE}-station-type`]: licenceDetails?.StationType ?? '-',

            [`${VENDOR_INFORMATION}-company-name`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorName ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorName) ??
                '-',
            [`${VENDOR_INFORMATION}-vendor-licence-number`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorLicenceNumber ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorLicenceNumber) ??
                '-',
            [`${VENDOR_INFORMATION}-contact-person`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.contactPerson ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.contactPerson) ??
                '-',
            [`${VENDOR_INFORMATION}-contact-number`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.ContactNumber ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.ContactNumber) ??
                '-',

            [`${VENDOR_ADDRESS}-address-type`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.addressType ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.addressType) ??
                '-',
            [`${VENDOR_ADDRESS}-address-line-1`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.foreignAddress1 ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.foreignAddress1) ??
                '-',
            [`${VENDOR_ADDRESS}-address-line-2`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.foreignAddress2 ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.foreignAddress2) ??
                '-',
            [`${VENDOR_ADDRESS}-address-line-3`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.foreignAddress3 ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.foreignAddress3) ??
                '-',
            [`${VENDOR_ADDRESS}-address-line-4`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.foreignAddress4 ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.foreignAddress4) ??
                '-',
            [`${VENDOR_ADDRESS}-address-line-5`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.foreignAddress5 ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.foreignAddress5) ??
                '-',
            [`${VENDOR_ADDRESS}-city`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.city ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.city) ??
                '-',
            [`${VENDOR_ADDRESS}-state`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.state ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.state) ??
                '-',
            [`${VENDOR_ADDRESS}-zip-code`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.zipCode ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.zipCode) ??
                '-',
            [`${VENDOR_ADDRESS}-country`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.country ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.country) ??
                '-',
            [`${VENDOR_ADDRESS}-building-name`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.buildingName ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.buildingName) ??
                '-',
            [`${VENDOR_ADDRESS}-postal-code`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.postalCode ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.postalCode) ??
                '-',
            [`${VENDOR_ADDRESS}-street-name`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.streetName ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.streetName) ??
                '-',
            [`${VENDOR_ADDRESS}-block-house-no`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.blockNo ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.blockNo) ??
                '-',
            [`${VENDOR_ADDRESS}-floor-level`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.floor ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.floor) ??
                '-',
            [`${VENDOR_ADDRESS}-unit`]:
                (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.unit ||
                    licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.unit) ??
                '-',

            [`${STATION_DETAILS}-station-tabs`]: [
                { 'fixed-station-licence': [...baseLandFixedStationInfo] },
                { 'mobile-station-licence': [...mobilePortableStationInfo] }
            ],

            [`${MOBILE_FREQUENCY_INFO}-list`]: mobileStationFrequencyInfo ?? [...mobileStationFrequencyInfo],
            [`${LAND_FIXED_RADIO_EQUIPMENT_INFO}-list`]: landFixedEquipmentInfo ?? [...landFixedEquipmentInfo],
            [`${LAND_FIXED_FREQUENCY_INFO}-list`]: landFixedStationFrequencyInfo ?? [...landFixedStationFrequencyInfo],
            [`${FILTER_INFORMATION}-list`]: filterInfo ?? [...filterInfo],

            [`${ANTENNA_INFORMATION}-antenna-manufacturer`]: licenceDetails?.baseLandFixedStationInfo[0]?.antennaManufacturer ?? '-',
            [`${ANTENNA_INFORMATION}-polarization`]: licenceDetails?.baseLandFixedStationInfo[0]?.polarization ?? '-',
            [`${ANTENNA_INFORMATION}-antenna-effective-height`]:
                licenceDetails?.baseLandFixedStationInfo[0]?.antennaEffectiveHeightMAboveGroundLevel ?? '-',
            [`${ANTENNA_INFORMATION}-antenna-elevation-angle`]: licenceDetails?.baseLandFixedStationInfo[0]?.elevationAngle ?? '-',

            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-north-latitude-displacement`]:
                licenceDetails?.baseLandFixedStationInfo[0]?.northLatitudeDisplacement ?? '-',
            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-east-longitude-displacement`]:
                licenceDetails?.baseLandFixedStationInfo[0]?.eastLongitudeDisplacement ?? '-',
            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-gain-db`]: licenceDetails?.baseLandFixedStationInfo[0]?.gainDB ?? '-',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '-',
                [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '-',
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '-',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '-',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '-',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-licence-details',
            formID: 'renew-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '-',
                [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '-',
                [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '-',

                [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '-',
                [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '-',
                [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '-',
                [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '-',
                [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '-',
                [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? '-'
            }
        };
    }

    if (transactionType === 'Amend') {
        const mapped = (
            licenceDetails?.iwantToAmend ||
            licenceDetails?.licenceDetails?.iwantToAmend ||
            licenceDetails?.iWantToUpdate ||
            licenceDetails?.licenceDetails?.iWantToUpdate
        )?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-special-purpose-station-licence',
            formID: 'amend-special-purpose-station-licence',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
            values: {
                [`${OTHER_DETAILS}-amend-table`]: Array.isArray(mapped) && mapped.length > 0 ? [...mapped] : [],
                [`${OTHER_DETAILS}-proposed-used-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystem ?? '-',

                [`${STATION_TYPE}-station-type`]: licenceDetails?.StationType ?? '-',

                [`${VENDOR_INFORMATION}-company-name`]:
                    (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorName ||
                        licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorName) ??
                    '-',
                [`${VENDOR_INFORMATION}-vendor-licence-number`]:
                    (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorLicenceNumber ||
                        licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorLicenceNumber) ??
                    '-',
                [`${VENDOR_INFORMATION}-contact-person`]:
                    (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.contactPerson ||
                        licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.contactPerson) ??
                    '-',
                [`${VENDOR_INFORMATION}-contact-number`]:
                    (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.ContactNumber ||
                        licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.ContactNumber) ??
                    '-',

                [`${VENDOR_ADDRESS}-building-name`]:
                    (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.buildingName ||
                        licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.buildingName) ??
                    '-',
                [`${VENDOR_ADDRESS}-postal-code`]:
                    (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.postalCode ||
                        licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.postalCode) ??
                    '-',
                [`${VENDOR_ADDRESS}-street-name`]:
                    (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.streetName ||
                        licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.streetName) ??
                    '-',
                [`${VENDOR_ADDRESS}-block-house-no`]:
                    (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.blockNo ||
                        licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.blockNo) ??
                    '-',
                [`${VENDOR_ADDRESS}-floor-level`]:
                    (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.floor ||
                        licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.floor) ??
                    '-',
                [`${VENDOR_ADDRESS}-unit`]:
                    (licenceDetails?.mobilePortableStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.unit ||
                        licenceDetails?.baseLandFixedStationInfo[0]?.equipmentInfo[0]?.vendorInformation?.vendorAddress?.unit) ??
                    '-',

                [`${STATION_DETAILS}-station-tabs`]: [
                    { 'fixed-station-licence': [...baseLandFixedStationInfo] },
                    { 'mobile-station-licence': [...mobilePortableStationInfo] }
                ],

                [`${MOBILE_FREQUENCY_INFO}-list`]: mobileStationFrequencyInfo ?? [...mobileStationFrequencyInfo],
                [`${LAND_FIXED_RADIO_EQUIPMENT_INFO}-list`]: landFixedEquipmentInfo ?? [...landFixedEquipmentInfo],
                [`${LAND_FIXED_FREQUENCY_INFO}-list`]: landFixedStationFrequencyInfo ?? [...landFixedStationFrequencyInfo],
                [`${FILTER_INFORMATION}-list`]: filterInfo ?? [...filterInfo],

                [`${ANTENNA_INFORMATION}-antenna-manufacturer`]: licenceDetails?.baseLandFixedStationInfo[0]?.antennaManufacturer ?? '-',
                [`${ANTENNA_INFORMATION}-polarization`]: licenceDetails?.baseLandFixedStationInfo[0]?.polarization ?? '-',
                [`${ANTENNA_INFORMATION}-antenna-effective-height`]:
                    licenceDetails?.baseLandFixedStationInfo[0]?.antennaEffectiveHeightMAboveGroundLevel ?? '-',
                [`${ANTENNA_INFORMATION}-antenna-elevation-angle`]: licenceDetails?.baseLandFixedStationInfo[0]?.elevationAngle ?? '-',

                [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-north-latitude-displacement`]:
                    licenceDetails?.baseLandFixedStationInfo[0]?.northLatitudeDisplacement ?? '-',
                [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-east-longitude-displacement`]:
                    licenceDetails?.baseLandFixedStationInfo[0]?.eastLongitudeDisplacement ?? '-',
                [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-gain-db`]: licenceDetails?.baseLandFixedStationInfo[0]?.gainDB ?? '-',

                [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    return licence;
};

const spsApplicationPayload = {
    formatSPSApplication
};

export default spsApplicationPayload;
